// Load optional features only when their markup exists, including quick-add,
// section rendering, and sections inserted by the theme editor.
const config = document.getElementById('optional-component-modules');
const pending = new Map(Object.entries(JSON.parse(config?.textContent || '{}')));
let selector = [...pending.keys()].join(',');

function scan(root) {
  if (!selector || !(root instanceof Element || root instanceof Document)) return;
  const matches = [...root.querySelectorAll(selector)];
  if (root instanceof Element && root.matches(selector)) matches.unshift(root);
  for (const element of matches) {
    const url = pending.get(element.localName);
    if (!url) continue;
    pending.delete(element.localName);
    if (!customElements.get(element.localName)) {
      import(url).catch((error) => {
        console.error(`Unable to load ${element.localName}`, error);
        pending.set(element.localName, url);
        selector = [...pending.keys()].join(',');
      });
    }
  }
  selector = [...pending.keys()].join(',');
}

scan(document);
new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) scan(node);
  }
}).observe(document.documentElement, { childList: true, subtree: true });
